const investigationsTutorial = {
  module: 'investigations',
  moduleName: 'Investigations',
  steps: [
    { target: '.inv-event-list', position: 'top', title: 'Correlation Events', description: 'Every door access, intercom call, and FR match from all your integrations flows into this unified feed in real time.' },
    { target: '.inv-event-row', position: 'right', title: 'Event Detail', description: 'Click any event to see the full context — who triggered it, which device, what actions fired, and the raw system data.' },
    { target: '.inv-filters', position: 'bottom', title: 'Severity Filters', description: 'Filter by severity, source system, or date range to zero in on suspicious activity.' },
    { target: '.inv-pane-footer', position: 'top', title: 'Create a Case', description: 'Escalate any event into an investigation case. Cases let you group related events, add notes, and assign to a team member.' },
    { target: '.inv-tab-cases', position: 'bottom', title: 'Cases Tab', description: 'Track open investigations, their status, priority, and assigned investigator all in one place.' },
  ],
};

export default investigationsTutorial;
